import { render, staticRenderFns } from "./MergeRequestsPage.vue?vue&type=template&id=07ab8d01&"
import script from "./MergeRequestsPage.vue?vue&type=script&lang=js&"
export * from "./MergeRequestsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports